import { combineReducers } from "redux";

import referReducer, {
  initialState as initialReferState
} from "@tvg/refer/src/reducers";

import capiReducer, {
  initialState as initialCapiState
} from "./App/capiReducer";

import appReducer, { initialState as initialAppState } from "./App/appReducer";

import userDataReducer, {
  initialState as initialUserState
} from "./App/userDataReducer";

export const initialState = {
  capi: initialCapiState,
  app: initialAppState,
  userData: initialUserState,
  refer: initialReferState
};

export default combineReducers({
  capi: capiReducer,
  app: appReducer,
  userData: userDataReducer,
  refer: referReducer
});
